import React from "react";
import { Box } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";

import KPIComparator from "components/visuals/KPIComparator";

import { operations, selectors } from "modules/customer/insights/performance/overview/keyPerformanceIndicators";

const ForecastSalesYTG = () => {
    const dispatch = useDispatch();
    const forecastSalesYTG = useSelector(state => selectors.forecastSalesYTG(state));
    const { loading, error, value, percentageDifference } = forecastSalesYTG;
    const label = "Forecast revenue in the year to go vs the same period last year";
    const valueFormatted = numberFormatter.toGBP(value, 1);

    React.useEffect(() => {
        dispatch(operations.getForecastSalesYTG());
    }, [dispatch]);

    return (
        <Box width="100%" height="100%" data-cy="forecast-sales-ytg">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default ForecastSalesYTG;
